<template>
  <div class="home">
    首页介绍
    <a-button type="primary" @click="gotoLogin"></a-button>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {},
  mounted() {},
  methods: {
    gotoLogin() {
      this.$router.replace('login');
    },
  },
};
</script>
